import { HttpRequest } from "./utils/HttpRequest";
import {
  TransportCompaniesResponse,
  AddTransportCompanyResponse,
  TransportAuthorizationsResponse,
  TransportEventType,
  RequestTransportAuthorizationPayload,
  RequestTransportAuthorizationResponse,
  ResendTransportAuthorizationRequestResponse,
  ApproveTransportAuthorizationPayload,
  ApproveTransportAuthorizationResponse,
} from "./types/transportTypes";

export default class Transport {
  httpReq = new HttpRequest();

  getTransportCompanies(token: string, search?: string): Promise<TransportCompaniesResponse> {
    const body: { token: string; search?: string } = { token };
    if (search) {
      body.search = search;
    }
    return this.httpReq.post(`ws-security/transport/getTransportCompanies`, body);
  }

  addTransportCompany(token: string, name: string): Promise<AddTransportCompanyResponse> {
    return this.httpReq.post(`ws-security/transport/addTransportCompany`, {
      token,
      name,
    });
  }

  getTransportAuthorizations(
    token: string,
    transportCompany: string,
    eventType: TransportEventType,
    driverDni?: string
  ): Promise<TransportAuthorizationsResponse> {
    const body: {
      token: string;
      transportCompany: string;
      eventType: TransportEventType;
      driverDni?: string;
    } = { token, transportCompany, eventType };
    if (driverDni) {
      body.driverDni = driverDni;
    }
    return this.httpReq.post(`ws-security/transport/getTransportAuthorizations`, body);
  }

  requestTransportAuthorization(
    payload: RequestTransportAuthorizationPayload
  ): Promise<RequestTransportAuthorizationResponse> {
    return this.httpReq.post(`ws-security/transport/requestTransportAuthorization`, payload);
  }

  resendTransportAuthorizationRequest(
    token: string,
    id: string
  ): Promise<ResendTransportAuthorizationRequestResponse> {
    return this.httpReq.post(`ws-security/transport/resendTransportAuthorizationRequest`, {
      token,
      id,
    });
  }

  approveTransportAuthorization(
    payload: ApproveTransportAuthorizationPayload
  ): Promise<ApproveTransportAuthorizationResponse> {
    return this.httpReq.post(`ws-security/transport/approveTransportAuthorization`, payload);
  }
}
